<template>
    <div class="spo-card pa-2 rounded my-2 bordered">
        <SportipsButton class="ml-auto mb-4" icon="mdi-close" @click="$emit('close')">Fermer</SportipsButton>
        <div class="d-flex flex-column gap mb-4">

            <SportipsButton chevron action-button full-width icon="mdi-magnify" @click="launchSearch()">Lancer la
                recherche</SportipsButton>
            <div v-for="filter in preInscriptionStore.filters" :key="filter.name">
                <label class="field_label" for="filter_type">{{ filter.label }}</label>
                <v-select v-if="filter.type == 'select'" v-model="filter.value" :items="filter.options"
                    item-title="label" item-value="value" hide-details></v-select>
                <v-text-field v-if="filter.type == 'text'" v-model="filter.value" hide-details></v-text-field>
                <v-text-field v-if="filter.type == 'number'" type="number" v-model="filter.value"
                    hide-details></v-text-field>
                <div v-if="filter.type == 'boolean'">
                    <v-btn-group density="compact">
                        <v-btn @click="filter.value = 'Non'" variant="elevated" :elevation="0" b
                            :color="filter.value == 'Non' ? 'darkblue' : ''" class="no-uppercase">Non</v-btn>
                        <v-btn @click="filter.value = ''" variant="elevated" :elevation="0"
                            :color="filter.value == '' ? 'darkblue' : ''" class="no-uppercase">Indifférent</v-btn>
                        <v-btn @click="filter.value = 'Oui'" variant="elevated" :elevation="0"
                            :color="filter.value == 'Oui' ? 'darkblue' : ''" class="no-uppercase">Oui</v-btn>
                    </v-btn-group>

                </div>
            </div>

            <!-- Section pour exclure des courses -->
            <div class="mt-6">
                <label class="field_label mb-2">Exclure des courses</label>
                <div v-for="course in courses" :key="course.id" class="mb-2">
                    <v-checkbox :model-value="preInscriptionStore.excluded_courses.includes(course.id)"
                        @update:model-value="preInscriptionStore.toggleExcludedCourse(course.id)"
                        :label="`Exclure la course ${course.nom}`" hide-details density="compact"></v-checkbox>
                </div>
            </div>
        </div>

        <SportipsButton chevron action-button full-width icon="mdi-magnify" @click="launchSearch()">Lancer la
            recherche</SportipsButton>


    </div>
</template>

<script>
import { mapStores } from "pinia";
import { usePreInscriptionStore } from "@/stores/preinscriptionStore";
export default {

    data() {
        return {

        }
    },
    methods: {
        async launchSearch() {
            await this.preInscriptionStore.search();
            //scroll to the top of the page
            window.scrollTo(0, 0);
        }
    },

    computed: {
        ...mapStores(usePreInscriptionStore),
        courses() {
            if (!this.preInscriptionStore.courses_by_id) {
                return [];
            }
            return Object.values(this.preInscriptionStore.courses_by_id);
        }
    },

    mounted() {

    }

}
</script>

<style lang="scss" scoped></style>